export const formTypeAlias = {
    case_references: 'referee',
    external: 'candidate',
    "external/form": 'candidate',
    ADDITIONAL_TENANT_FORM: 'tenant',
};
